// ========================================================
// FAST HIT Website — Loading Screen
// ========================================================

import './LoadingScreen.css';

type LoadingScreenProps = {
  message?: string;
};

export function LoadingScreen({ message = 'Loading...' }: LoadingScreenProps) {
  return (
    <div className="loading-screen" role="status" aria-live="polite">
      <div className="loading-screen__content">
        <div className="loading-screen__logo">
          <span className="loading-screen__logo-text">FAST HIT</span>
        </div>
        <div className="loading-screen__spinner">
          <div className="loading-screen__ring" />
        </div>
        <p className="loading-screen__message">{message}</p>
      </div>
    </div>
  );
}
